import { Helper } from '@/services/helper';
import moment from 'moment-timezone';
import numeral from 'numeral';

const helper = new Helper();

const CustomFilters = {
  install: (Vue, options) => {
    Vue.filter('formatNumber', value => {
      // displaying other groupings/separators is possible, look at the docs
      return numeral(value).format('0,0');
    });
    Vue.filter('formatMB', value => {
      const mb = 0.000001;
      // displaying other groupings/separators is possible, look at the docs
      return numeral(value * mb).format('0.0000') + ' MB';
    });
    Vue.filter('formatProgramType', value => helper.resolveProgramType(value));
    Vue.filter('formatGB', value => {
      const mb = 0.000001;
      const b = 1073741824;
      if (value >= b) {
        return numeral(value / b).format('0.000') + ' GB';
      } else {
        return numeral(value * mb).format('0.0000') + ' MB';
      }
      // displaying other groupings/separators is possible, look at the docs
    });
    Vue.filter('formatState', value => {
      try {
        switch (value) {
          case 10:
            return `${value} - Pending`;
          case 20:
            return `${value} - Running`;
          case 30:
            return `${value} - Completed`;
          case 40:
            return `${value} - Canceled`;
          case 99:
            return `${value} - Error`;
          default:
            return `${value} - Unknown`;
        }
      } catch (e) {
        return '-';
      }
    });
    Vue.filter('formatDateTime', function(value) {
      try {
        const offset = moment().utcOffset();
        return moment
          .utc(value)
          .utcOffset(offset)
          .format('L LTS');
      } catch (e) {
        return '-';
      }
    });
    Vue.filter('formatDateTimeShort', value => {
      try {
        return moment(value)
          .local()
          .format('MM/DD/YYYY hh:mm:ss a');
      } catch (e) {
        return '-';
      }
    });
    Vue.filter('formatDateTimeWithTimezone', (time, timezone) => {
      try {
        return moment(time)
          .tz(timezone)
          .format('MM/DD/YYYY hh:mm a');
      } catch (e) {
        return '-';
      }
    });
    Vue.filter('timezoneAbbr', (time, timezone) => {
      try {
        return moment(time)
          .tz(timezone)
          .zoneAbbr();
      } catch (e) {
        return '-';
      }
    });
    Vue.filter('formatDate', value => {
      try {
        return moment(value)
          .local()
          .format('MM/DD/YYYY');
      } catch (e) {
        return '-';
      }
    });
    Vue.filter('truncate', (value, size) => {
      let limit = 50;
      if (size && size > 0) {
        limit = size;
      }
      if (value && value.length > limit) {
        try {
          return value.substring(0, limit) + '...';
        } catch (e) {
          return value;
        }
      }
      return value;
    });
    Vue.filter('formatMS', value => {
      if (value > 1000 && value < 60000) {
        const seconds = value / 1000;
        return numeral(seconds).format('0.0000') + 's';
      } else if (value >= 60000) {
        const seconds = value / 60000;
        return numeral(seconds).format('0.0000') + 'm';
      }
      return numeral(value).format('0.0000') + 'ms'; // displaying other groupings/separators is possible, look at the docs
    });
    Vue.filter('pretty', value => {
      try {
        return JSON.stringify(JSON.parse(value), null, 2);
      } catch (e) {
        return value;
      }
    });
  }
};
export default CustomFilters;
